module.exports = __webpack_public_path__ + "static/wrothampark-17f51a33ed885f0308c4025b749f97f2.jpg";